import React from 'react';
import { CompanyDetails } from 'cpnl-common';
import { DataOverview, DefinitionList, DefinitionListItem } from '@cp-shared-19/frontend-ui';
import { useTranslation } from 'react-i18next';
import { Heading } from '@vwfs-bronson/bronson-react';

export const CompanyDetailsSection: React.FC<{ companyDetails?: CompanyDetails }> = ({ companyDetails }) => {
    const { t } = useTranslation('my-profile');

    const companyDetailsItems: DefinitionListItem[] = [
        {
            label: t('company-details.company-name'),
            value: companyDetails?.companyName,
        },
        {
            label: t('company-details.kvk-number'),
            value: companyDetails?.kvkNumber,
        },
    ].filter((item) => item.value);

    const companyContactDetailsItems: DefinitionListItem[] = [
        {
            label: t('company-details.e-mail'),
            value: companyDetails?.businessEmail,
        },
        {
            label: t('company-details.mobile-phone'),
            value: companyDetails?.businessMobilePhone,
        },
        {
            label: t('company-details.main-phone'),
            value: companyDetails?.businessMainPhone,
        },
    ].filter((item) => item.value);

    return companyDetails ? (
        <>
            <Heading level={2} className={'u-mt'}>
                {t('section-headline-company-information')}
            </Heading>
            <DataOverview title={t('company-details.sub-headline.company')} titleLevel={3}>
                <DefinitionList split={true} list={companyDetailsItems} />
            </DataOverview>
            <DataOverview title={t('company-details.sub-headline.contact')} titleLevel={3}>
                <DefinitionList split={true} list={companyContactDetailsItems} />
            </DataOverview>
        </>
    ) : null;
};
